import React from "react";
import PlaceholderPage from "./PlaceholderPage";

/** Placeholder page for viewing and sorting received contact messages. */
const ContactMessages: React.FC = () => (
	<PlaceholderPage
		title="Contact Messages"
		description="Review inbound contact messages, triage responses, and sync them with downstream CRM pipelines."
	/>
);

export default ContactMessages;

